export default "__VITE_PUBLIC_ASSET__55e2f5bf__"